<template>
  <v-card
    class="user-profile-card"
    flat
    tile
    :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-1'"
  >
    <v-card-title class="d-flex justify-space-between align-center">
      <span>Personal Information</span>
      <span class="edit"  @click="clientPortalUrl()" >Go Client Portal to Edit</span>
    </v-card-title>
    <v-card-actions>
      <v-card-text class="py-0 pr-0">
        <v-card-text class="pa-0">
          <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
            <span>Country: </span>
            <span>{{ profile?.countries?.name || "N/A" }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
            <span>Phone No: </span>
            <span>{{ profile?.mobile || "N/A" }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
            <span>State: </span>
            <span>{{ profile?.states?.name || "N/A" }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
            <span>Date of Birth: </span>
            <span>{{ formatDate(profile?.dob) || "N/A" }}</span>
          </v-card-subtitle>
        </v-card-text>
      </v-card-text>
      <v-card-text class="py-0 pr-0">
        <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
          <span>City: </span>
          <span>{{ profile?.cities?.name || "N/A" }}</span>
        </v-card-subtitle>
        <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
          <span>Zipcode: </span>
          <span>{{ profile?.postal_code || "N/A" }}</span>
        </v-card-subtitle>
        <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
          <span>Street Address: </span>
          <span>{{ profile?.address || "N/A" }}</span>
        </v-card-subtitle>
        <v-card-subtitle v-if="profile?.b_book_com_rate" class="pa-0 mb-2 listing-v-card__subtitle">
          <span>Profit Percentage: </span>
          <span>{{ profile?.b_book_com_rate || "N/A" }}%</span>
        </v-card-subtitle>
      </v-card-text>
    </v-card-actions>
  </v-card>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {};
  },

  computed: {
    ...mapState("profile", ["profile"]),
  },

  methods: {
    ...mapActions("profile", [PROFILE__ACTIONS.PROFILE]),
    formatDate(value) {
      if (
        Object.prototype.toString.call(value) === "[object Date]" &&
        !isNaN(value.getTime())
      ) {
        return value.toISOString().split("T")[0];
      }
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toISOString().split("T")[0];
      } else {
        return null;
      }
    },

    clientPortalUrl() {
            if(!this.profile) return;

            window.open(this.profile.client_portal_url, "_blank");
            return;
        }
  },

  async mounted() {
    try {
      await this[PROFILE__ACTIONS.PROFILE]();
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
